import React, { useEffect, useState } from 'react';
import PageHeader from 'app/components/PageHeader';
import { Box, Button, CircularProgress, Grid, Menu, MenuItem, Typography } from '@mui/material';
import { addUserBtn, btnStatusPayment, inputsBox, sendBtn, statusPayment } from './ClientProfilePage.sx';
import CustomInput from 'app/components/CustomInput';
import SuccessModal from 'app/components/SuccessModal';
import useClientProfilePage from './useClientProfilePage';
import CustomSelect from 'app/components/CustomSelect';
import CustomSwitch from 'app/components/CustomSwitch';
import UserAddIcon from 'app/components/Icons/UserAddIcon';
import AccordionCustom from 'app/components/AccordionCustom';
import logger from 'app/utils/logger';
import { menuItems } from 'app/components/AccordionCustom/EmployeeSummary/EmployeeSummary.sx';
import EditIcon from 'app/components/Icons/EditIcon';
import LockIcon from 'app/components/Icons/LockIcon';
import BinIcon from 'app/components/Icons/BinIcon';
import AsanConfirmation from 'app/components/AsanConfirmation';
import EmployeeAddPage from 'app/pages/EmployeeAddPage';
import { grayDefault, grayFilter } from 'app/components/ThemeProvider/colors';

const ClientProfilePage = () => {
  const {
    handleSend,
    successModal,
    setSuccessModal,
    options,
    control,
    register,
    filterBtns,
    btnId,
    handleChangePageType,
    pageType,
    statusFilterBtns,
    statusBtnId,
    setStatusBtnId,
    handleEmployeeAdd,
    isLoadingGetEmployeeList,
    isLoadingGetUserProfile,
    dataGetUserProfile,
    dataGetEmployeeList,
    userStatus,
    privateMobil,
    privateEmail,
    handleChangeEmail,
    handleChangePhone,
    handleChangeSignType,
    signType,
    details,
    handleClickMenuUsers,
    asanConfirmation,
    setAsanConfirmation,
    edit,
    dataEmployeeUpsert,
    employeeStatus,
    handleMenuClick,
    handleClose,
    activeAnchor,
    anchorEl,
    setBtnId,
    employeeIdUser,
  } = useClientProfilePage();

  if (edit) {
    return (
      <EmployeeAddPage
        edit={true}
        userData={dataEmployeeUpsert?.user_data}
        rulesData={dataEmployeeUpsert?.rules_data}
        employeeList={dataEmployeeUpsert?.employee_list}
        businessKey={dataEmployeeUpsert?.business_key}
      />
    );
  }

  return (
    <>
      <PageHeader pageName={'Müştəri profili'} />
      <Box sx={{ display: 'flex', gap: '8px' }}>
        {filterBtns.map((item, index) => (
          <Button
            key={item.id}
            color={'tertiary'}
            sx={
              btnId === item.id
                ? { ...btnStatusPayment, background: 'white', boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)' }
                : btnStatusPayment
            }
            onClick={() => handleChangePageType(item.id)}
          >
            {item.title}
          </Button>
        ))}
      </Box>
      {isLoadingGetEmployeeList ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            height: '100%',
          }}
        >
          <CircularProgress />
        </Box>
      ) : pageType === 'information' ? (
        <>
          <Box sx={inputsBox}>
            <Grid sx={{ width: '700px' }} container rowSpacing="16px">
              <Grid item xs={6}>
                <CustomInput title={'Soyad'} placeholder={'Soyad'} disabled={true} rest={{ ...register('lname') }} />
              </Grid>
              <Grid item xs={6}>
                <CustomInput title={'Ad'} placeholder={'Ad'} disabled={true} rest={{ ...register('fname') }} />
              </Grid>
              <Grid item xs={6}>
                <CustomInput
                  title={'Ata adı'}
                  placeholder={'Ata adı'}
                  disabled={true}
                  rest={{ ...register('mname') }}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInput
                  title={'Vəzifə'}
                  placeholder={'Vəzifə'}
                  disabled={true}
                  rest={{ ...register('position') }}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInput title={'Fin kod'} placeholder={'Fin kod'} disabled={true} rest={{ ...register('fin') }} />
              </Grid>
              <Grid item xs={6}></Grid>
              <Grid item xs={6}>
                <CustomInput
                  title={'E-mail'}
                  placeholder={'E-mail'}
                  disabled={true}
                  value={privateEmail}
                  handleChange={handleChangeEmail}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInput
                  title={'Mobil nömrə'}
                  placeholder={'Mobil nömrə'}
                  value={privateMobil}
                  disabled={true}
                  handleChange={handleChangePhone}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomSelect
                  title={'İmza üsulu'}
                  options={options}
                  placeholder={'İmza üsulu'}
                  rest={{ ...register('signMethod') }}
                  control={control}
                  // disabled={true}
                  onChange={handleChangeSignType}
                  value={signType}
                />
              </Grid>
              {/*<Grid sx={{ display: 'flex', alignItems: 'center', marginTop: '16px' }} item xs={6}>*/}
              {/*  <CustomSwitch title={'Google Authenticator'} />*/}
              {/*</Grid>*/}
            </Grid>
          </Box>
          <Box sx={{ display: 'flex', width: '100%', marginTop: '16px', justifyContent: 'right' }}>
          <Button onClick={handleSend} color={'tertiary'} sx={sendBtn}>
            Yadda saxla
          </Button>
          <SuccessModal
            successText={'Dəyişiklər uğurla yadda saxlanıldı!'}
            open={successModal}
            close={setSuccessModal}
          />
          </Box>
        </>
      ) : (
        pageType === 'users' && (
          <>
            <Box sx={{ display: 'flex', gap: '8px', marginTop: '30px' }}>
              {statusFilterBtns.map((item, index) => (
                <Button
                  key={item.id}
                  color={statusBtnId === item.id ? 'info' : 'tertiary'}
                  size={'medium'}
                  sx={
                    statusBtnId === item.id
                      ? {
                          ...statusPayment(item.id),
                        }
                      : {
                          ...btnStatusPayment,
                          background: 'transparent',
                          border: 1,
                          height: '32px',
                          borderRadius: '20px',
                          borderWidth: '2px',
                          borderColor: grayDefault,
                        }
                  }
                  onClick={() => setStatusBtnId(item.id)}
                >
                  <Typography
                    sx={{
                      fontSize: '14px',
                      fontWeight: '500',
                      lineHeight: '20px',
                      color: statusBtnId === item.id && 'white',
                    }}
                  >
                    {item.title}
                  </Typography>
                </Button>
              ))}
            </Box>
            <Box sx={{ display: 'flex', gap: '18px', flexDirection: 'column', marginTop: '20px' }}>
              {statusBtnId === 1
                ? dataGetEmployeeList?.employees.map((item: any, index: any) => (
                    <AccordionCustom
                      id={item.id}
                      key={item.id}
                      headerText={`${item.fname} ${item.lname}`}
                      pageName={'profile'}
                      employeeStatus={employeeStatus}
                      status={item.status === 'active' ? userStatus[0] : item.status === 'blocked' && userStatus[1]}
                      position={'Əməkdaş'}
                      email={item.email}
                      anchorEl={anchorEl}
                      activeAnchor={activeAnchor}
                      handleClose={handleClose}
                      handleMenuClick={handleMenuClick}
                    />
                  ))
                : statusBtnId === 2
                ? dataGetEmployeeList?.employees
                    .filter((item: any) => item.status === 'active')
                    .map((item: any, index: any) => (
                      <AccordionCustom
                        id={item.id}
                        key={item.id}
                        headerText={`${item.fname} ${item.lname}`}
                        pageName={'profile'}
                        status={userStatus[0]}
                        position={'Əməkdaş'}
                        employeeStatus={employeeStatus}
                        email={item.email}
                        anchorEl={anchorEl}
                        activeAnchor={activeAnchor}
                        handleClose={handleClose}
                        handleMenuClick={handleMenuClick}
                      />
                    ))
                : statusBtnId === 3 &&
                  dataGetEmployeeList?.employees
                    .filter((item: any) => item.status === 'blocked')
                    .map((item: any, index: any) => (
                      <AccordionCustom
                        id={item.id}
                        key={item.id}
                        headerText={`${item.fname} ${item.lname}`}
                        pageName={'profile'}
                        employeeStatus={employeeStatus}
                        status={userStatus[1]}
                        position={'Əməkdaş'}
                        email={item.email}
                        anchorEl={anchorEl}
                        activeAnchor={activeAnchor}
                        handleClose={handleClose}
                        handleMenuClick={handleMenuClick}
                      />
                    ))}

              <Menu
                id={activeAnchor}
                disableAutoFocusItem
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                sx={{ '& .MuiPaper-root': { right: '30px', left: 'auto !important' } }}
              >
                {employeeStatus === 'active'
                  ? details
                      .filter((item: any) => item.value !== 'unblock')
                      .map((detail, index) => (
                        <MenuItem
                          key={detail.title}
                          onClick={() => handleClickMenuUsers(detail.value, employeeIdUser)}
                          sx={
                            index + 1 === details.length
                              ? {
                                  ...menuItems,
                                  color: '#FF5F57',
                                  '&:hover': { color: '#FF5F57', background: '#F3F4F6' },
                                }
                              : menuItems
                          }
                        >
                          {detail.icon}
                          <Typography>{detail.title}</Typography>
                        </MenuItem>
                      ))
                  : employeeStatus === 'blocked'
                  ? details
                      .filter((item: any) => item.value !== 'block')
                      .map((detail, index) => (
                        <MenuItem
                          key={detail.title}
                          onClick={() => handleClickMenuUsers(detail.value, employeeIdUser)}
                          sx={
                            index + 1 === details.length
                              ? {
                                  ...menuItems,
                                  color: '#FF5F57',
                                  '&:hover': { color: '#FF5F57', background: '#F3F4F6' },
                                }
                              : menuItems
                          }
                        >
                          {detail.icon}
                          <Typography>{detail.title}</Typography>
                        </MenuItem>
                      ))
                  : details.map((detail, index) => (
                      <MenuItem
                        key={detail.title}
                        onClick={() => handleClickMenuUsers(detail.value, employeeIdUser)}
                        sx={
                          index + 1 === details.length
                            ? {
                                ...menuItems,
                                color: '#FF5F57',
                                '&:hover': { color: '#FF5F57', background: '#F3F4F6' },
                              }
                            : menuItems
                        }
                      >
                        {detail.icon}
                        <Typography>{detail.title}</Typography>
                      </MenuItem>
                    ))}
              </Menu>
            </Box>
            <Button onClick={handleEmployeeAdd} sx={addUserBtn}>
              <UserAddIcon />
              <Typography sx={{ fontSize: '17px', fontWeight: 600 }}>Yeni əməkdaş əlavə et</Typography>
            </Button>
            {asanConfirmation && (
              <AsanConfirmation
                open={asanConfirmation}
                close={setAsanConfirmation}
                // verifyCode={dataSendToSign?.verification_code}
                // timerTime={dataSendToSign?.timer}
                // pathUrl={dataSendToSign?.path_url}
                // businessKey={dataSendToSign?.business_key}
              />
            )}
          </>
        )
      )}
    </>
  );
};

export default ClientProfilePage;
